import { useState } from "react";
import { format, parse } from "date-fns";
import { tr } from "date-fns/locale";
import { Calendar as CalendarIcon } from "lucide-react";
import { Button } from "@/components/ui/button";
import { Calendar } from "@/components/ui/calendar";
import { Popover, PopoverContent, PopoverTrigger } from "@/components/ui/popover";
import { cn } from "@/lib/utils";

// value/onChange use ISO "yyyy-MM-dd" strings; display is Turkish dd.MM.yyyy
export function DatePicker({ value, onChange, placeholder = "Tarih seçin", testid, className, clearable }) {
  const [open, setOpen] = useState(false);
  let selected;
  try { selected = value ? parse(value, "yyyy-MM-dd", new Date()) : undefined; } catch { selected = undefined; }
  return (
    <Popover open={open} onOpenChange={setOpen} modal={true}>
      <PopoverTrigger asChild>
        <Button
          type="button"
          variant="outline"
          data-testid={testid}
          className={cn("rounded-sm justify-start text-left font-normal w-full bg-white", !value && "text-muted-foreground", className)}
        >
          <CalendarIcon className="mr-2 h-4 w-4 shrink-0" />
          {value && selected ? format(selected, "dd.MM.yyyy", { locale: tr }) : placeholder}
        </Button>
      </PopoverTrigger>
      <PopoverContent className="w-auto p-0 z-[70]" align="start" onOpenAutoFocus={(e) => e.preventDefault()}>
        <Calendar
          mode="single"
          locale={tr}
          showOutsideDays={false}
          selected={selected}
          defaultMonth={selected}
          onSelect={(d) => { if (d) { onChange(format(d, "yyyy-MM-dd")); setOpen(false); } else if (clearable) { onChange(""); setOpen(false); } }}
          initialFocus
        />
        {clearable && value && (
          <div className="p-2 border-t border-border">
            <Button type="button" variant="ghost" size="sm" className="w-full rounded-sm" onClick={() => { onChange(""); setOpen(false); }}>Temizle</Button>
          </div>
        )}
      </PopoverContent>
    </Popover>
  );
}
